var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7c41f4f9133299524b69924a45ba3ea53263cce9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cloud-frontend@materializeinc"]={id:"7c41f4f9133299524b69924a45ba3ea53263cce9"};
      